// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
import qs from "qs";

const QueryStringService = {
  get: () => {
    if (
      typeof window === "undefined" ||
      typeof window.location === "undefined"
    ) {
      return null;
    }

    const queryStringObject = qs.parse(window.location.search, {
      ignoreQueryPrefix: true,
    });

    return queryStringObject;
  },
  getParam: (param: string) => {
    const queryStringObject = QueryStringService.get();

    if (queryStringObject) {
      return queryStringObject[param];
    }

    return null;
  },
  cleanUrlParam(param: string) {
    //Custom delimiter for '/' that  needs to be replaced server-side
    param = param.replace("/", "|*|");

    param = encodeURIComponent(param);

    return param;
  },
};

export default QueryStringService;
